// @ts-nocheck

export type OwnerListWithProperties = typeof OwnerListWithProperties[keyof typeof OwnerListWithProperties];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OwnerListWithProperties = {
  true: 'true',
  false: 'false',
} as const;
